/**
 * Hero background preload — единый источник правды.
 *
 * Фоновый SVG hero-секции оказывается LCP-элементом на всех страницах, где он
 * рендерится, поэтому браузер обязан узнать о нём как можно раньше. Самый
 * ранний из доступных сигналов — HTTP-заголовок `Link` (приходит до первого
 * байта HTML), его ставит `proxy.ts`. React-preload внутри `HeroBackground`
 * остаётся страховкой на случай маршрута, не покрытого списком ниже.
 *
 * Модуль не импортирует ничего из приложения: его тянет прокси, который
 * работает в отдельном рантайме.
 */

export const HERO_BACKGROUND_SRC = '/about/img/hero-header.svg';

export const HERO_PRELOAD_LINK_HEADER =
  `<${HERO_BACKGROUND_SRC}>; rel=preload; as=image; type="image/svg+xml"; fetchpriority=high`;

/** Маршруты, которые рендерят hero: каталог + статические страницы с PageHeader. */
const HERO_STATIC_ROUTES = new Set([
  '/about',
  '/contact',
  '/delivery',
  '/faq',
  '/privacy',
  '/terms',
]);

export function isHeroRoute(pathname: string): boolean {
  // Каталог: /shop и любые его подстраницы (город, категория, бренд).
  if (pathname === '/shop' || pathname.startsWith('/shop/')) return true;

  // Со слешем на конце тоже: /about/ и /about — один и тот же маршрут.
  const normalized = pathname.length > 1 ? pathname.replace(/\/$/, '') : pathname;
  return HERO_STATIC_ROUTES.has(normalized);
}
